import { UnitAndLesson, UnitAndLessonModel } from "@/models";
import { RemoteTeachingService, TeacherService } from "@/services";

export const getListUnitByClassAndGroup = async (classId: string, groupId: string) => {
  const listUnit: UnitAndLesson[] = [];

  const lessonSetting = await TeacherService.getClassLessonSetting(classId, groupId);
  if (!lessonSetting) return listUnit;

  const { versionGroupId, remoteLessonPlanVersionId, maxUnit } = lessonSetting;
  if (!versionGroupId && !remoteLessonPlanVersionId) return listUnit;

  const lessons = await RemoteTeachingService.getRemoteLessons(versionGroupId!, -1, maxUnit, remoteLessonPlanVersionId);

  lessons.map((res: UnitAndLessonModel) => {
    let isUnitExist = false;
    listUnit.map((singleUnit: UnitAndLesson) => {
      if (res.unitId == singleUnit.unitId) {
        isUnitExist = true;
      }
    });
    if (!isUnitExist) {
      listUnit.push({
        unit: res.unit,
        sequence: [],
        unitId: res.unitId,
      });
    }
  });
  lessons.map((res: UnitAndLessonModel) => {
    listUnit.map((singleUnit: UnitAndLesson, index) => {
      if (res.unitId == singleUnit.unitId) {
        listUnit[index].sequence.push(res.sequence);
      }
    });
  });

  listUnit.sort((a, b) => a.unit - b.unit);
  return listUnit;
};
